var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 53,
    viewBox: "0 0 52 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1672_20797)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1.375,
    width: 48,
    height: 48,
    rx: 10,
    fill: "#FFD6E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 18.6252V17.7918C30 16.6251 30 16.0417 29.782 15.596C29.5903 15.204 29.2843 14.8853 28.908 14.6856C28.4802 14.4585 27.9201 14.4585 26.8 14.4585H25.2C24.0799 14.4585 23.5198 14.4585 23.092 14.6856C22.7157 14.8853 22.4097 15.204 22.218 15.596C22 16.0417 22 16.6251 22 17.7918V18.6252M24 24.3543V29.5627M28 24.3543V29.5627M17 18.6252H35M33 18.6252V30.2918C33 32.042 33 32.9171 32.673 33.5856C32.3854 34.1736 31.9265 34.6516 31.362 34.9512C30.7202 35.2918 29.8802 35.2918 28.2 35.2918H23.8C22.1198 35.2918 21.2798 35.2918 20.638 34.9512C20.0735 34.6516 19.6146 34.1736 19.327 33.5856C19 32.9171 19 32.042 19 30.2918V18.6252",
    stroke: "#EA1D63",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1672_20797",
    x: 0,
    y: 0.375,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1672_20797"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1672_20797",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashSquare);
export default __webpack_public_path__ + "static/media/trashSquare.c79f02e3752eb15d62fda624c63947f5.svg";
export { ForwardRef as ReactComponent };